import { setSuggestionPillIds } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setSuggestionPillIds, function (actionMessage) {
    getStore().suggestionPillIds = actionMessage.suggestionPillIds;
});
//# sourceMappingURL=setSuggestionPillIdsMutator.js.map